import { API } from "../../apiSlice";

export const getTotalPendingDepositsApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    getTotalPendingDeposits: builder.query({
      query: () => {
        return {
          url: "users/pending-deposits",
        };
      },
    }),
  }),
});

export const { useGetTotalPendingDepositsQuery } =
  getTotalPendingDepositsApiSlice;
